import actions from "./actions";

const initialState = {
  isLoading: false,
  error: null,
  transactions: [],
  transaction: {},
  totalPages: 0,
};

export default function assessmentReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_TRANSACTION_LIST:
      return { ...state, ...action.payload };
    case actions.SET_TRANSACTION_DETAIL:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
